<div class="container-fluid ps-md-0">
	<div class="row g-0">
	  	<div class="d-none d-md-flex col-md-4 col-lg-6 bg-image">
            <div class="graphic-image" *ngIf="isManualLoginAllowed">
            </div>
        </div>
		<div class="col-md-8 col-lg-6">
			<div class="login d-flex align-items-center py-5">
				<div class="container">
					<div class="row">
						<div class="col-md-9 col-lg-8 mx-auto">
							<h2 class="brand-head mb-3">
								SiePro - Siemens Procurement
							</h2>
							<div class="brand-description">
								<p>
									Digitalization of Complete Procurement Solution in a Single Platform (Purchase Requisition, Sourcing Decision, Quote Evaluations, Purchase Order (PO) processing & PO Expedition)
								</p>
							</div>
							<h4 class="login-heading mb-4">Welcome back!</h4>
							<ng-container *ngIf="isManualLoginAllowed">
                                <form>
                                    <div class="mb-3">
                                        <label for="floatingInput">Enter your User ID to login</label>
                                        <input type="text" class="form-control" id="floatingInput" 
                                        aria-describedby="emailHelp" [(ngModel)]="userID">
                                    </div>
                                    <div class="d-grid">
                                        <button class="btn btn-lg btn-primary btn-login text-uppercase fw-bold mb-2 text-white"
                                            (click)="login()">
                                        Get Started
                                        </button>
                                    </div>	
                                </form>
                            </ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>